/**
 * Copyright 2022 Beijing Volcano Engine Technology Co., Ltd. All Rights Reserved.
 * SPDX-license-identifier: BSD-3-Clause
 */
import {
  AI_MODEL,
  AI_MODEL_MODE,
  AI_MODE_PROMPT,
  ARK_V3_MODEL_ID,
  ModelSourceType,
  TTS_CLUSTER,
  VOICE_TYPE,
} from './config';

export const AIGC_PROXY_HOST = 'https://volcengine-demo-api.sh3.agoralab.co/proxyAIGCFetch';

/**
 * @brief Defining RTC & AIGC config
 * @notes If you wanna get full config and description of params, refer to https://api.volcengine.com/api-explorer?action=StartVoiceChat&groupName=%E6%99%BA%E8%83%BD%E4%BD%93&serviceCode=rtc&version=2024-06-01
 */
export class Config {
  AppId = '6777c43634f47d01720535c1';

  /**
   * @brief Not necessary.
   */
  BusinessId?: string;
  // BusinessId?: string = 'Your BusinessId';

  RoomId = 'RTCBotTestRoom01';

  UserId = 'RTCBotTestUser01';

  Token = '0016777c43634f47d01720535c1VgBPHLEDCph7Z4rShGcQAFJUQ0JvdFRlc3RSb29tMDEQAFJUQ0JvdFRlc3RVc2VyMDEGAAAAitKEZwEAitKEZwIAitKEZwMAitKEZwQAitKEZwUAitKEZyAA1zMNVPfJG6MspdTckBHN14FzpWvegotEXUJgSGioaBk=';

  ASRConfig = {
    AppId: '6674704640',
    Cluster: 'volcengine_streaming',
  };

  TTSConfig = {
    AppId: '6674704640',
    VoiceType: VOICE_TYPE.通用女声,
    Cluster: TTS_CLUSTER.TTS,
  };

  LLMConfig = {
    // ModelName: AI_MODEL.DOUBAO_LITE_4K,
    ModelName: AI_MODEL.DOUBAO_PRO_32K,
    Mode: AI_MODEL_MODE.ARK_V3,
    ModelVersion: '1.0',
    WelcomeSpeech: '欢迎使用火山引擎视频云 RTC 驱动的虚拟人大模型',
    SystemMessages: [AI_MODE_PROMPT[AI_MODEL.DOUBAO_PRO_32K]],
    EndPointId: ARK_V3_MODEL_ID[AI_MODEL.DOUBAO_PRO_32K],

    ModeSourceType: ModelSourceType.Available,
    APIKey: 'sk-659025a1cfd748b7bbb9e98157cd1cde',
    Url: 'https://dashscope.aliyuncs.com/compatible-mode/v1/chat/completions',
    Feature: JSON.stringify({ Http: true }),
  };

  BotName = 'RobotMan_';

  getAIGCConfig() {
    return {
      AppId: this.AppId,
      BusinessId: this.BusinessId,
      Config: {
        BotName: this.BotName,
        LLMConfig: this.LLMConfig,
        TTSConfig: this.TTSConfig,
        ASRConfig: this.ASRConfig,
      },
    };
  }
}

const config = new Config();

export * from './config';
export default config;
